import {
    type UploadTokenResponseType,
    type UploadTokenRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForEventLogo = async (params: UploadTokenRequestType): Promise<UploadTokenResponseType> => {
    return await request<UploadTokenResponseType>("/events/getUploadTokenForEventLogo", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForEventLogo;
